module.exports = __webpack_public_path__ + "img/finance2.522eeffc.jpg";